<template>
  <div>
    <div class="d-flex justify-content-center">
      <div class="container d-flex justify-content-between p-tb-10">
        <div>您好，欢迎使用{{ siteInfo.name }}</div>
        <div class="head-title hidden-sm cursor"><span @click="collect">收藏本站</span> | <span @click="setHome">设为首页</span> | 
          <span v-if="store.isLogin">{{store.name}}</span>
          <span v-else @click="()=>router.push('/login')">立即登录</span>
        </div>
      </div>
    </div>
    <div class="header" :style="{'background-image':`url(${headImg})`}">
      <h1 class="container">{{ siteInfo.name }}</h1>
    </div>
    
    <div class="navi d-flex justify-content-center hidden-sm">
      <div class="container align-items-center d-flex  justify-content-between text-center">
        <div class="d-flex align-items-center text-light head-nav">
          <router-link to="/" :class="['pdlr-10 sm-padding-10',route.path=='/'?'active':'']">首页</router-link>
          <a v-for="(i,v) in naviList" :key="i.id" :href="'#/' + i.url" 
          :class="['pdlr-10 sm-padding-10',route.path.indexOf(i.src_url) >= 0 ? 'active':'']">{{i.name}}</a>
          <router-link to="/myapply" :class="['pdlr-10 sm-padding-10',route.path.indexOf('myapply')>=0 ? 'active':'']">我的申报</router-link>
        </div>
        <router-link v-if="!store.isLogin" to="/login" class="loginBtn">立即登录</router-link>
        <a @click="ontuichu" v-else class="loginBtn">{{store.name}}，退出登录</a>
      </div>
    </div>
    <div style="min-height:64vh">
      <router-view></router-view>
    </div>
    <div class="footer">
      <div class="hidden-sm">
        <div class="container d-flex justify-content-center pt-4  pb-4 text-light ">
          主办方:{{siteInfo.unit_name}}&nbsp;&nbsp;&nbsp; 技术支持：<a class="text-muted" href="https://jsj.hhtc.edu.cn/" target="_blank">怀化学院计算机科学与工程学院</a>&nbsp;&nbsp;&nbsp;&nbsp;<a class="text-muted" href="https://www.ddx.red/" target="_blank">湖南红橘子科技有限公司</a> &nbsp;&nbsp;&nbsp;&nbsp;备案号：湘ICP备20015375号-1 &nbsp;&nbsp;
        </div>
      </div>
      <div class="p-4 text-light col-sm-0 hidden-md">
        <div>主办方:{{ siteInfo.unit_name }}</div>
        <div>技术支持：<a class="text-muted" href="https://jsj.hhtc.edu.cn/" target="_blank">怀化学院计算机科学与工程学院</a>&nbsp;&nbsp;&nbsp;&nbsp;<a class="text-muted" href="https://www.ddx.red/" target="_blank">湖南红橘子科技有限公司</a></div>
        <div>备案号：{{ siteInfo.copy_right }} </div>
      </div>
    </div>
    
  </div>
</template>

<script setup>
import { useRoute,useRouter } from 'vue-router';
import { onMounted,ref } from 'vue';
import {getSiteBaseInfo, getuserinfo} from '@/api'
import {useUserStore} from '@/store/login'
import message from '@/utils/message';
import img from '@/assets/headImg.png'
const route=useRoute()
const router=useRouter()
let naviList=ref([]);
let siteInfo = ref({});
let headImg=ref(img)

const store=useUserStore()
onMounted(()=>{
  if(typeof(route.query.acid) != 'undefined' && route.query.acid > 0){
    store.setAcid(route.query.acid);
  } 
  if(typeof(route.query.token) !== 'undefined'){
    store.setToken(route.query.token);
    message('success','登录成功！',()=>{},3000)
  } 
  if(typeof(route.query.name) !== 'undefined'){
    store.setName(route.query.name);
  } 
  getinfo()
  getSiteBaseInfo().then(res=>{
    if(res.rs){
      naviList.value = res.data.navmenu_list;
      siteInfo.value = res.data.siteInfo;
      document.title = res.data.siteInfo.name;
      headImg.value=res.data.banner.image_path?res.data.banner.image_path:img
    }
  })
})

function getinfo() {
  getuserinfo().then(res => {
    console.log(res)
  })
}

function ontuichu() {
  store.loginOut()
  router.push();
}
function collect(){
  message('success','请使用 Ctrl + D 收藏本站',()=>{},3000)
}
function setHome(){
  message('success','请手动将本站设置为首页',()=>{},3000)
}
</script>

<style scoped lang="less">
.pdlr-10 {
  margin-right: 20px;
}
@media screen and (max-width: 750px) {
  .pdlr-10 {
    font-size: 14px;
    box-sizing: border-box;
  }
}

.max-1200{
    max-width: 1200px;
}
.w-1200 {
 width: 1200px;
}
.main-box{
    margin:0 auto;
}
.head-title{
  span{
    cursor: pointer;
    &:hover{
      color:#3780be;
    }
  }
}
.content{
    background: #f2f2f2;
}
.header {
  background-position: top center;
  height: 156px;
  padding-top: 50px;
  h1 {
    margin: 0 auto;
    color: #ffffff;
  }
}
.loginBtn{
  cursor: pointer;
  padding: 5px;
  min-width: 90px;
  overflow: hidden;
  border-radius: 4px;
  background: #f2f2f2;
  color:#3D3D3D!important;
}
.active{
  background:#ee7c3d;
}
.section-box  {
    .inner-box { padding: 10px 15px; }
}
.footer{
    background: #3780be;
    font-size: 12px;
}
.head-nav{
  text-align: center;
  a{
    border-radius: 4px;
  }
}
.navi {
  background: #3780be;
  min-height: 80px;
  padding: 6px 0;
  position: sticky;
  top: 0;
  z-index: 10;
  overflow: visible !important;
  a{
    color: #ffffff;
    display: inline-block;
    overflow: visible !important;
  }
}
.section-title{
    display: flex;
    justify-content: space-between;
    margin: 15px 0;
}
.dottle{
    position: relative;
    padding-left: 30px;
    &::after{
        content: '';
        position:absolute;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #3780be;
        left: 15px;
        top: 50%;
        transform: translateY(-50%);
    }
}
a{
  text-decoration: none;
}
.footer a:visited,
.footer a { color: #fff !important; }
</style>